<div class="flex w-full items-center justify-center">
  <div
    class="mb-16 flex h-full w-full max-w-2xl flex-col items-center justify-center gap-2 p-2"
  >
    @if (startValidation()) {
      @if (showQrCodeSig()) {
        <a class="" [href]="uri()" target="_blank">
          {{ 'Apri link QR' | siaTranslate }}
        </a>
        <img [src]="qrCodeString()" alt="QR Code" />
        <span>
          {{
            'Inquadra il codice QR con un dispositivo e immetti il codice di verifica per autenticarti'
              | siaTranslate
          }}
        </span>
      } @else {
        <span class="justify-normal">
          {{ 'É stato inviato un codice alla seguente email' | siaTranslate }}
          <span class="font-semibold">{{ emailSig() }}</span>
        </span>
      }
      <form
        (ngSubmit)="validateTotp()"
        class="flex w-full flex-col items-center gap-2"
      >
        <mat-form-field class="sia-login w-full" appearance="outline">
          <mat-label>{{ 'Codice OTP' | siaTranslate }}</mat-label>
          <input
            matInput
            [ngModel]="otp()"
            (ngModelChange)="otp.set($event)"
            name="otp"
            type="text"
            autocomplete="one-time-code"
          />
        </mat-form-field>
        <div class="flex w-full flex-col items-center gap-2 md:flex-row">
          @if (type2fa() == 'email') {
            <button
              mat-flat-button
              [disabled]="buttonDisable()"
              class="secondary w-full"
              type="button"
              (click)="startGenerationQrCode('email')"
            >
              {{ 'Richiedi nuovo codice' | siaTranslate }} {{ minutes() }}:{{
                seconds()
              }}
            </button>
          }
          <button mat-flat-button class="secondary w-full" type="submit">
            {{ 'Verifica codice' | siaTranslate }}
          </button>
        </div>
      </form>
    } @else {
      <div class="flex w-full flex-col items-center gap-2 md:flex-row">
        <button
          mat-button
          class="secondary w-full"
          (click)="startGenerationQrCode('app')"
        >
          {{ 'Abilita tramite APP' | siaTranslate }}
        </button>
        <button
          mat-button
          class="secondary w-full"
          (click)="startGenerationQrCode('email')"
        >
          {{ 'Abilita tramite EMAIL' | siaTranslate }}
        </button>
      </div>
    }
  </div>
</div>
